import { render } from "./Figure1.vue?vue&type=template&id=110ecfd4&bindings={}"
import script from "./Figure1.vue?vue&type=script&lang=ts"
export * from "./Figure1.vue?vue&type=script&lang=ts"
script.render = render

export default script